<template>
  <AppAlertInPage
    variant="info"
    :no-icon="true"
    :has-left-border="false"
    :dismissible="true"
    @input="dismiss"
  >
    {{ $t('views.DocumentSearchPage.snippetNoteText') }}
  </AppAlertInPage>
</template>

<script setup lang="ts">
import { useStore } from 'vuex'

import { SEARCH_SNIPPET_NOTE_DISMISSED } from '@/common/constants'
import { setUserSetting } from '@/common/utils/userSettings'
import AppAlertInPage from '@/design-system/alert/AppAlertInPage.vue'

const store = useStore()

function dismiss(): void {
  const userId = store.state.user.profile.id
  setUserSetting(userId, SEARCH_SNIPPET_NOTE_DISMISSED, true)
  store.commit('documents/SET_SEARCH_PAGE_RESULTS_SNIPPET_NOTE', false)
}
</script>
